import { makeStyles } from '@material-ui/styles'

export default makeStyles(_ => ({
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    width: '30vw',
  },
}))
